/* eslint-disable */
import {SETUSER, SETUSEROUT, SETARTWORKS} from "../actions/actionType";
const INITIAL_DATA = {
  user: {},
  artworks: [],
};

const users = (state = INITIAL_DATA, action) => {
  switch (action.type) {
    case SETUSER:
      return {
        ...state,
        user: action.data,
      };
    case SETARTWORKS:
      return {
        ...state,
        artworks: action.data,
      };
    case SETUSEROUT:
      return {
        ...state,
        user: {},
      };

    default:
      return state;
  }
};

export default users;
